import api from 'api/api';
import { DEVICE_ID } from 'utils/constants';
import { IFormValues } from './FxTransferRequest.model';

const ON_SUBMITS = (values: IFormValues, otp: string) => {
  const requestBody = {
    ...values,
    password: otp,
    passwordType: 'OTP',
    transType: 'SERVICE-CHARGE',
    deviceID: DEVICE_ID,
  };
  return api.post('transfer/fxTransferRequest', requestBody);
};

export default ON_SUBMITS;
